import { Button, Text } from "snap-design-system";
import { useDialogActions } from "~/store/dialogStore";

interface UnsavedChangesDialogProps {
  onCancel: () => void;
}

export function UnsavedChangesDialog({ onCancel }: UnsavedChangesDialogProps) {
  const { executePendingConfirmAction } = useDialogActions();

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col">
        <Text >
          Você possui alterações que ainda não foram salvas.
        </Text>
        <Text >
          Deseja realmente sair sem salvar?
        </Text>
      </div>
      <div className="flex gap-3 w-full justify-end">
        <Button
          size={"small"}
          onClick={executePendingConfirmAction}
          variant="ghost"
          className="hover:opacity-70"
        >
          Sair sem salvar
        </Button>
        <Button
          size={"small"}
          onClick={onCancel}
        >
          Continuar editando
        </Button>
      </div>
    </div>
  );
}
